import { render, staticRenderFns } from "./SamInput.vue?vue&type=template&id=1fba1de7&scoped=true&shadow"
import script from "./SamInput.vue?vue&type=script&lang=js&shadow"
export * from "./SamInput.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamInput.vue?vue&type=style&index=0&id=1fba1de7&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1fba1de7",
  null
  ,true
)

export default component.exports